var _filter, _filter2, _rect, _g, _ellipse, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogAiBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#050d2e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#0a1a4e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0d1f5c"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGlow",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4facfe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00f2fe"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGlow2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f093fb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f5576c"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGlow3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#43e97b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38f9d7"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softglow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "centerGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4facfe",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#050d2e",
      stopOpacity: 0
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 400,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    stroke: "#4facfe",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 1200,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 1200,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 1200,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 200,
    x2: 1200,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 250,
    x2: 1200,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 300,
    x2: 1200,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 350,
    x2: 1200,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 0,
    x2: 200,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 0,
    x2: 300,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 600,
    y1: 0,
    x2: 600,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 0,
    x2: 700,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 0,
    x2: 800,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 900,
    y1: 0,
    x2: 900,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000,
    y1: 0,
    x2: 1000,
    y2: 400
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1100,
    y1: 0,
    x2: 1100,
    y2: 400
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 200,
    rx: 400,
    ry: 250,
    fill: "url(#centerGlow)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#4facfe",
    strokeWidth: 0.8,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 100,
    x2: 340,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 100,
    x2: 340,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 100,
    x2: 340,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 200,
    x2: 340,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 200,
    x2: 340,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 200,
    x2: 340,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 200,
    x2: 340,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 300,
    x2: 340,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 300,
    x2: 340,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 300,
    x2: 340,
    y2: 320
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    stroke: "#4facfe",
    strokeWidth: 0.8,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 80,
    x2: 500,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 80,
    x2: 500,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 80,
    x2: 500,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 160,
    x2: 500,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 160,
    x2: 500,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 160,
    x2: 500,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 160,
    x2: 500,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 240,
    x2: 500,
    y2: 140
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 240,
    x2: 500,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 240,
    x2: 500,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 240,
    x2: 500,
    y2: 340
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 320,
    x2: 500,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 320,
    x2: 500,
    y2: 340
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    stroke: "#4facfe",
    strokeWidth: 0.8,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 60,
    x2: 660,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 60,
    x2: 660,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 140,
    x2: 660,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 140,
    x2: 660,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 200,
    x2: 660,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 200,
    x2: 660,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 200,
    x2: 660,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 280,
    x2: 660,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 280,
    x2: 660,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 340,
    x2: 660,
    y2: 280
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    stroke: "#4facfe",
    strokeWidth: 0.8,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 120,
    x2: 820,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 120,
    x2: 820,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 120,
    x2: 820,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 200,
    x2: 820,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 200,
    x2: 820,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 200,
    x2: 820,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 200,
    x2: 820,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 280,
    x2: 820,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 280,
    x2: 820,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 280,
    x2: 820,
    y2: 320
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#4facfe",
    strokeWidth: 0.8,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 80,
    x2: 980,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 80,
    x2: 980,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 160,
    x2: 980,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 160,
    x2: 980,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 240,
    x2: 980,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 240,
    x2: 980,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 240,
    x2: 980,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 320,
    x2: 980,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 320,
    x2: 980,
    y2: 300
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    stroke: "#4facfe",
    strokeWidth: 0.8,
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 100,
    x2: 1080,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 200,
    x2: 1080,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 200,
    x2: 1080,
    y2: 250
  }), /*#__PURE__*/React.createElement("line", {
    x1: 980,
    y1: 300,
    x2: 1080,
    y2: 250
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 100,
    r: 7,
    fill: "url(#nodeGlow)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 200,
    r: 7,
    fill: "url(#nodeGlow)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 300,
    r: 7,
    fill: "url(#nodeGlow)",
    opacity: 0.9
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 80,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 160,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 240,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 320,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 60,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 140,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 200,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 280,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 340,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softglow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 120,
    r: 9,
    fill: "url(#nodeGlow)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 200,
    r: 11,
    fill: "url(#nodeGlow)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 280,
    r: 9,
    fill: "url(#nodeGlow)",
    opacity: 1
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 80,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 160,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 240,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 320,
    r: 6,
    fill: "url(#nodeGlow3)",
    opacity: 0.85
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 100,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 200,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 300,
    r: 6,
    fill: "url(#nodeGlow2)",
    opacity: 0.85
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 150,
    r: 7,
    fill: "url(#nodeGlow)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1080,
    cy: 250,
    r: 7,
    fill: "url(#nodeGlow)",
    opacity: 0.9
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#4facfe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 60,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 360,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 40,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 370,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 380,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 40,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1140,
    cy: 340,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 100,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 250,
    r: 2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 195,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: 800,
    fill: "white",
    opacity: 0.08,
    letterSpacing: 8
  }, "ARTIFICIAL INTELLIGENCE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 385,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#4facfe",
    opacity: 0.4,
    letterSpacing: 4
  }, "AI IN TRAVEL TECHNOLOGY")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogAiBanner);
export default __webpack_public_path__ + "static/media/blog-ai-banner.bbd1111e41aa4976df5a13976a988bc8.svg";
export { ForwardRef as ReactComponent };